import styled from 'styled-components';
import RestaurantIconSvg from '../../assets/hotels/amenities/restaurant.svg';

const RestaurantIcon = styled(RestaurantIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default RestaurantIcon;
